export enum DrawingModes {
  OFF_ZONES = 'offZones',
  FILTERS = 'filters',
}
